import React, {useEffect} from "react";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useGetLongNotesAnalysisQuery } from "../../../../redux/service/modules/dashboard";
import { useSelector } from "react-redux";
import Sectors from "../../../../components/table/Sectors";
import TableLayout from "../../../../components/layout/TableLayout";

const Longnotes = ({ appliedFilters, setRequiredFilters }) => {
  useEffect(() => {
    setRequiredFilters(['sector'])
    return () => {
      // Clean up effect when component unmounts
      setRequiredFilters([])
    }
  }, [])
  const dateRange = useSelector((state) => state.date);
  const customCellRender = {
    ambit_sector: (row) => {
      let sectorList = row?.ambit_sector || []
      if(sectorList.includes(';')) {
        sectorList = sectorList.split(';')
      } else if(sectorList.includes(',')) {
        sectorList = sectorList.split(',')
      } else {
        sectorList = [sectorList]
      }
      return <Sectors sectors={sectorList} maxVisible={2}/>
    }
  }
  return (
    <TableLayout>
      <PaginatedDataTable
        queryHook={useGetLongNotesAnalysisQuery}
        initialDateRange={dateRange}
        firstColumnWidth="100px"
        isHeaderBold={true}
        isColumnSticky={true}
        stickyColumnsCount={1}
        totalText="Overall Research"
        headerFontSizes={["20px", "18px", "12px"]}
        headerHeights={["1.5rem", "1rem", "1rem"]}
        headerGap={true}
        appliedFilters={appliedFilters}
        customCellRender={customCellRender}
      />
    </TableLayout>
  );
};

export default Longnotes;
